export type ReadingDays = Record<string, Record<string, number>>;
export interface BookReadingProfile {
  days: ReadingDays;
  books: Record<string, { progress: number; lastOpenedAt: string }>;
}
export const emptyReadingProfile: BookReadingProfile = { days: {}, books: {} };
export function localReadingDay(date: Date) {
  return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
}
// Split at local midnight so Sunday/Monday sessions belong to the right week.
export function addReadingTime(days: ReadingDays, bookId: string, start: number, end: number): ReadingDays {
  if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return days;
  const result = { ...days };
  let cursor = start;
  while (cursor < end) {
    const date = new Date(cursor), key = localReadingDay(date);
    const midnight = new Date(date.getFullYear(),date.getMonth(),date.getDate()+1).getTime();
    const next = Math.min(midnight,end);
    result[key] = { ...result[key], [bookId]: (result[key]?.[bookId] ?? 0) + next-cursor };
    cursor = next;
  }
  return result;
}
export function readingSummary(profile: BookReadingProfile, now = new Date()) {
  const monday = new Date(now.getFullYear(),now.getMonth(),now.getDate()-((now.getDay()+6)%7));
  const from = localReadingDay(monday), today = localReadingDay(now);
  const books = new Set<string>(); let weekMs = 0, totalMs = 0;
  for (const [day, entries] of Object.entries(profile.days)) {
    for (const [bookId, milliseconds] of Object.entries(entries)) {
      const ms = Number.isFinite(milliseconds) ? Math.max(0,milliseconds) : 0;
      totalMs += ms;
      if (day >= from && day <= today) { books.add(bookId); weekMs += ms; }
    }
  }
  return { weekBooks: books.size, weekSeconds: Math.floor(weekMs/1000), totalSeconds: Math.floor(totalMs/1000) };
}
export function readingDuration(seconds: number) {
  if (seconds < 60) return `${Math.floor(seconds)} 秒`;
  if (seconds < 3600) return `${Math.floor(seconds/60)} 分钟`;
  return `${Math.floor(seconds/3600)} 小时 ${Math.floor(seconds%3600/60)} 分钟`;
}
